<template>
    <div>
     <b-modal  v-model="mostrar" size="m" hide-footer  hide-header-close no-close-on-backdrop>   
      <b-card-body>
  
        <b-form-group label="Nombre del trimestre" >
            <b-form-input
             v-model="nombre"
             :class="{invalid_input: $v.nombre.$error}"
          ></b-form-input>
        </b-form-group>
       
        <b-col md="12">
        <b-row style="text-align: center">
         <b-col>
            <b-button variant="danger"  size="sm" @click="$emit('cancelar')">Cancelar</b-button>
          </b-col>
          <b-col>
            <b-button variant="primary" size="sm" @click="guardarTrimestre()" :disabled="enviando">Guardar</b-button>
          </b-col>   
        </b-row>
        </b-col>
      </b-card-body>
    </b-modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import axios from 'axios'
export default {
  name:"editorTrimestre",
  
  props: ["mostrar","trimestre"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
 
  validations:{
   nombre: { required } 
  },
  data: function() {
    return {
      enviando: false,
      nombre: ""
        
    };
  },
  methods: {   
    guardarTrimestre() {
        this.$v.$touch();  
        if (!this.$v.$invalid) {
        this.enviando = true;
        let ruta = this.trimestre ? this.httpURL + "/tesoreria/trimestre/"+this.trimestre._id : this.httpURL + "/tesoreria/trimestre"
        if(this.trimestre){
             axios.put(ruta,
            {nombre:this.nombre}, 
            {headers: { token: this.sessionToken }})
            .then(res => {
              this.enviando = false;
              this.$emit('actualizarTrimestre',res.data.trimestre);
              this.$emit('cancelar')
            })
            .catch(err => {
              this.$notify({ group: "gral_notif", type: "error", duration: 1500, speed: 500, text: "No se pudo establecer una conexión al servidor." });
            });
        }
        else{
            axios.post(ruta,
            {nombre:this.nombre}, 
            {headers: { token: this.sessionToken }})
            .then(res => {
              this.enviando = false;
              this.$emit('actualizarTrimestre',res.data.trimestre);
              this.$emit('cancelar')
            })
            .catch(err => {
              this.$notify({ group: "gral_notif", type: "error", duration: 1500, speed: 500, text: "No se pudo establecer una conexión al servidor." });
            });
        }
      }
      
    },
    
  },
  created() {

    this.nombre = this.trimestre ? this.trimestre.nombre : ""
  }
};
</script>
